export default "__VITE_ASSET__DPmvhbRS__"